import { render, staticRenderFns } from "./PNAssessments.vue?vue&type=template&id=48ed9d00"
import script from "./PNAssessments.vue?vue&type=script&lang=js"
export * from "./PNAssessments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports